module.exports = __webpack_public_path__ + "img/banner-tools.1616c2c3.png";